module.exports = __webpack_public_path__ + "media/promo/advent/images/garland-2-2-ad6798cf6a14483f989aef6d4772f943.png";